import React, { Component} from 'react';
import { connect } from 'react-redux';
import { submitAddRecord, recordAddFormChange, recordAddFormReset} from '../../actions/recordsActions';
import { Form, Icon, Input, Button} from 'antd';
const FormItem = Form.Item;
const { TextArea } = Input;

class RecordAddForm extends Component {

    showForm(){
        if(this.props.records.length === 0)
            return false
            
        return !this.props.records.every((item)=>item.coincidence !=100)
    }

    validation(updatedSubmission){
        updatedSubmission['validation']['serial_number'] = '';
        updatedSubmission['validation']['hid'] = '';

        if(updatedSubmission['serial_number'].length > 5 )
            updatedSubmission['validation']['serial_number'] = 'должно не более 5 цифр';

        if(updatedSubmission['hid'].length > 0 && !/^([0-9A-Z-]{2}[-]{1}){16,}$/.test(updatedSubmission['hid']+'-'))
            updatedSubmission['validation']['hid'] = 'не похоже на HID';

        return updatedSubmission;
    }

    updateSubmission(event){
        let updatedSubmission = Object.assign({}, this.props.record_add_form);

        updatedSubmission[event.target.id] = event.target.value;
        updatedSubmission['user'] = document.getElementById('user').value;

        updatedSubmission['serial_number'] = updatedSubmission['serial_number'].replace(/\D/ig, '');

        this.props.recordAddFormChange(this.validation(updatedSubmission));
    }

    submitSubmission(){
        this.props.submitAddRecord(this.props.record_add_form); 
        this.props.recordAddFormReset();
    }

    addFormHasErrors(){
        if(Object.keys(this.props.record_add_form.validation).some(item=>this.props.record_add_form.validation[item].length>0))
            return true;

        if(this.props.record_add_form.serial_number === '')
            return true;

        if(this.props.record_add_form.hid === '')
            return true;
    }

    render(){
        return (
            <Form layout="inline" style={{display: this.showForm() ? 'none' : 'block'}}>
                <FormItem 
                    validateStatus={this.props.record_add_form.validation.hid.length ? "error" : "success"}
                    help={this.props.record_add_form.validation.hid}
                >
                    <Input style={{width:'400px'}} prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} value={this.props.record_add_form.hid} onChange={this.updateSubmission.bind(this)} id="hid" type="text" placeholder= "HID" />
                </FormItem>
                <FormItem
                    validateStatus={this.props.record_add_form.validation.serial_number.length ? "error" : "success"}
                    help={this.props.record_add_form.validation.serial_number}
                >
                    <Input prefix={<Icon type="edit" style={{ color: 'rgba(0,0,0,.25)' }} />} value={this.props.record_add_form.serial_number} onChange={this.updateSubmission.bind(this)} id="serial_number" type="text" placeholder="VIDEOMAX-XXXXX" />
                </FormItem>
                <FormItem>
                    <Input style={{width:'600px'}} prefix={<Icon type="message" style={{ color: 'rgba(0,0,0,.25)' }} />} value={this.props.record_add_form.comments} onChange={this.updateSubmission.bind(this)} id="comments" type="text" placeholder="КОММЕНТАРИЙ" />
                    <Input type="hidden" id='user' name="user" value={localStorage.getItem('id')} />
                </FormItem>
                <FormItem>
                    <Button
                        type="primary"
                        htmlType="submit"
                        disabled={this.addFormHasErrors()}
                        onClick={this.submitSubmission.bind(this)}
                    >
                        добавить запись
                    </Button>
                </FormItem>
            </Form>
        )
    }
}

const mapStateToProps = state => ({
    record_add_form: state.records.record_add_form,
    records: state.records.records
})

const mapDispatchToProps = dispatch => ({
    submitAddRecord: payload => dispatch(submitAddRecord(payload)),
    recordAddFormChange: payload => dispatch(recordAddFormChange(payload)),
    recordAddFormReset: payload => dispatch(recordAddFormReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecordAddForm);


// WEBPACK FOOTER //
// ./src/components/containers/RecordAddForm.js